import { format } from 'date-fns/format';

export const formatTimestamp = (
  value: Date | string | number | undefined,
  fmt: string = "dd/MM/yyyy 'às' HH:mm'h'"
) => (value ? format(new Date(value), fmt) : '');
